'use client';

import type { ReactNode } from 'react';
import AskMapComponents from '@/components/AskMapComponents/AskMapComponents';
import useIsAskShowing from '@/hooks/useIsAskShowing';

export default function MapComponentsSlot({ children }: { children: ReactNode }) {
  // replace all map components with Ask's
  return useIsAskShowing() ? <AskMapComponents /> : children;
}
